/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Settings_TitleInputs */

const en_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy & Consent`)
};

const de_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz & Einwilligungen`)
};

const fr_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confidentialite et consentement`)
};

const es_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad y consentimiento`)
};

const it_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy e consenso`)
};

const nl_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy en toestemming`)
};

const pl_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatnosc i zgody`)
};

const fi_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietosuoja ja suostumukset`)
};

const da_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatliv og samtykke`)
};

const sv_consent_settings_title = /** @type {(inputs: Consent_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritet och samtycke`)
};

/**
* | output |
* | --- |
* | "Privacy & Consent" |
*
* @param {Consent_Settings_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consent_settings_title = /** @type {((inputs?: Consent_Settings_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Settings_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consent_settings_title(inputs)
	if (locale === "fr") return fr_consent_settings_title(inputs)
	if (locale === "es") return es_consent_settings_title(inputs)
	if (locale === "it") return it_consent_settings_title(inputs)
	if (locale === "nl") return nl_consent_settings_title(inputs)
	if (locale === "pl") return pl_consent_settings_title(inputs)
	if (locale === "fi") return fi_consent_settings_title(inputs)
	if (locale === "da") return da_consent_settings_title(inputs)
	if (locale === "sv") return sv_consent_settings_title(inputs)
	return en_consent_settings_title(inputs)
});